import React from 'react';

const ClientLogo = props => {
  return (
    <img src={props.src} alt="client logo" className={props.className || ''} />
  );
};

export default ClientLogo;
